import { Fragment, useEffect, useState } from "react";
import {
    Grid,
    TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ASMSelectV2 from "src/components/Select/ASMSelectV2";
import { EEPLanguageModel } from "src/models/businessManager/businessManager.model";
const requireStyle = {
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'red !important',
    },
    '& .MuiInputLabel-root': {
        color: 'red !important',
    }
};
function LinguisticSkillItem(props) {
    const { t } = useTranslation();
    const isVisu = props.isVisu;
    const levels = props.levels;
    const data = props.data;
    const [state, setState] = useState<EEPLanguageModel>({
        id: 0,
        idEa: 0,
        name: "",
        idLanguageLevel: 0
    });
    const deleteComponent = props.deleteComponent;

    useEffect(() => {
        if (data != undefined) {
            setState({
                id: data.id,
                idEa: data.idEa,
                name: data.name,
                idLanguageLevel: data.idLanguageLevel
            });
        }
    }, [data]);

    const handleChange = (e) => {
        setState({
            ...state,
            name: e.target.value
        });
    }

    const handleChangeLevel = (e) => {
        setState({
            ...state,
            idLanguageLevel: e.target.value
        });
    }

    const onBlur = () => {
        props.onBlur(state)
    }

    const handleChangeDataValue = () => {
        props.handleChangeDataValue(state)
    }

    return (
        <Fragment>
            <Grid container direction="row" alignItems="stretch" sx={{ padding: 1, marginLeft: 0, paddingLeft: 0 }} spacing={1} >
                <Grid item xs={6} style={{ paddingLeft: 0 }}>
                    <TextField
                        label={t('language.lang')}
                        variant="outlined"
                        required
                        name="name"
                        value={state.name}
                        onChange={handleChange}
                        onBlur={onBlur}
                        onBlurCapture={handleChangeDataValue}
                        onMouseLeave={handleChangeDataValue}
                        onDragLeave={handleChangeDataValue}
                        fullWidth
                        disabled={isVisu}
                        inputProps={{
                            maxLength: 126
                        }}
                        sx={(!isVisu && (state.name == null || state.name == "")) ? requireStyle : {}}
                    />
                </Grid>
                <Grid item xs={5} >
                    <div style={{ width: 472 }}>
                        <ASMSelectV2
                            labelId="level-label"
                            label={t('level.label')}
                            items={levels}
                            required
                            withRating={false}
                            withMultiSelect={false}
                            onChange={handleChangeLevel}
                            onBlur={onBlur}
                            onBlurCapture={handleChangeDataValue}
                            onMouseLeave={handleChangeDataValue}
                            onDragLeave={handleChangeDataValue}
                            // placeholder={t('level.select')}
                            defaultValue={state.idLanguageLevel >= 0 ? [state.idLanguageLevel] : []}
                            isDisabled={isVisu}
                            emptyField={(!isVisu && (state.idLanguageLevel == 0 || state.idLanguageLevel == null))}
                            fromLanguage={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                    {deleteComponent}
                </Grid>
            </Grid>
        </Fragment>
    );
}

export default LinguisticSkillItem;